<template>
  <div
    class="option-dropdown">
    <div
      v-on:click="showDropdown = !showDropdown && !(poolOption.choices.length < switchViewAt), logDropdownToggle(showDropdown, configurableOption.title, currPool, poolOption.choices.length < switchViewAt)"
      class="dropdown"
      :class="{'short': poolOption.choices.length < switchViewAt}"
      :style="{'max-height': configurableOption.value === '' ? '6.5em' : '4.5em', 'height': configurableOption.value === '' ? '6.5em' : '4.5em'}">
      <div class="descriptor">
        <h5 v-if="getT && configurableOption.title === 'Liner'">{{getT.static.summary[0].liner_label}}</h5>
        <h5 v-if="getT && configurableOption.title === 'Swim System'">{{getT.static.summary[0].system_label}}</h5>
        <h5 v-if="getT && configurableOption.title === 'Skirting'">{{getT.static.summary[0].skirting_label}}</h5>
        <h5 v-if="getT && configurableOption.title === 'Coping'">{{getT.static.summary[0].coping_label}}</h5>
        <h5 v-if="getT && configurableOption.title === 'Shell Colors'">{{getT.static.summary[0].shell_label}}</h5>
        <p>
          <span>{{ translatedName }}</span>
        </p>
      </div>
      <div class="title">
        <div
          class="button-wrap no-dropdown"
          v-if="poolOption.choices.length < switchViewAt">
          <button 
            v-for="(choice) in poolOption.choices"
            v-bind:key="choice.id"
            class="toggle"
            :class="{ 'active': configurableOption.value == choice.id }"
            v-on:click="setActive(choice)">
            <img :src="getImageUrl(`${choice.image}`)" :alt="choice.displayName">
          </button>
        </div>
        <div class="dropdown-header" v-if="poolOption.choices.length >= switchViewAt">
          <img
            class="thumbnail"
            :src="getImageUrl(`${ selectedChoice ? selectedChoice.image: 'no-selection-nobg.png' }`)"
            :alt="`${ selectedChoice ? selectedChoice.displayName : 'no selection' }`">
          <img
            class="arrow"
            :class="{ 'flip': this.showDropdown }"
            src="./../../assets/icons/right-arrow-small.svg"
            alt="Dropdown arrow">
        </div>
      </div>
      <p
        class="disclaimer"
        :class="{ 'show': configurableOption.value === '' }">
        {{ unsetDisclaimer }}
      </p>
    </div>
    <div
      class="dropdown-content"
      v-if="poolOption.choices.length >= switchViewAt"
      :class="{ 'show-dropdown': showDropdown && show }">
      <div class="button-wrap">
        <template v-for="item in sortedChoicesWithBreaks">
          <div class="flex-break" v-if="item.isBreak" :key="item.key"></div>
          <button 
            v-else
            :key="item.id"
            class="toggle"
            :class="{ 'active': configurableOption.value == item.id }"
            v-on:click="setActive(item)">
            <img :src="getImageUrl(`${item.image}`)" :alt="item.displayName">
          </button>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'OptionDropdownImage',
  props: [ 'optionKey', 'mutation', 'show', 'unsetDisclaimer' ],
  data() {
    /** Images are shown inline when # of options < switchViewAt
      * Images are shown inside a dropdown when # of options >= switchViewAt
      * Mobile: 3 options fit inline
      * Desktop: 4 options fit inline
      */
    const switchViewAt = window.innerWidth > 767 ? 4 : 3;

    return {
      showDropdown: false,
      switchViewAt,
    };
  },
  methods: {
    setActive(choice) {
      this.setSelectedOptionChoice(choice);
      this.$emit('clickedToggleOption', choice.id);
    },
    setSelectedOptionChoice(choice) {
      // Update UI state
      this.$store.dispatch('updateOptionSelections', { name: this.configurableOption.key, value: choice.id });
    },
    unsetSelectedOptionChoice() {
      // Update UI state
      this.$store.dispatch('updateOptionSelections', { name: this.configurableOption.key, value: '' });
    },
    getImageUrl(filename) {
      // There's a chance the image src is briefly 'undefined', use placeholder
      if (filename === 'undefined') {
        filename = 'no-selection-nobg.png';
      }

      var images = require.context('@/assets/images/');
      return images('./' + filename);
    },
    logDropdownToggle(showDropdown, optionName, model, noDropdown){
      // track event for Google Analytics
      if (!noDropdown) {
        if (showDropdown) {
          this.$gtag.event(optionName +' Options Expanded', {
            'event_category': optionName +' Options View Toggle',
            'event_label': optionName + ' Expanded',
            'selected_pool': model.title
          });
        } else {
          this.$gtag.event(optionName +' Options Collapsed', {
            'event_category': optionName +' Options View Toggle',
            'event_label': optionName + ' Collapsed',
            'selected_pool': model.title
          });    
        }
      }
    }
  },
  computed: {
    ...mapGetters(['getT', 'currPool']),
    poolOption: function() { return this.currPool.options[this.optionKey]; },
    configurableOption: function() { return this.$store.state.optionSelections[this.optionKey]; },
    selectedChoice: function() { 
      if (this.configurableOption.value) {
        return this.poolOption.choices.find(d=>d.id==this.configurableOption.value) 
      } else {
        return null;
      }
    },
    translatedName: function() { 
      return this.selectedChoice ? this.selectedChoice.displayName: '' 
    },
    sortedChoices: function() {
      return [...this.poolOption.choices].sort((a, b) => {
        // Lower group numbers appear first (at top due to row-reverse)
        return (a.group || 0) - (b.group || 0);
      });
    },
    /*
      for liner choices, EP is interested in the solids being listed first, and the non-solids, below those.
    */
    sortedChoicesWithBreaks: function() {
      const result = [];
      this.sortedChoices.forEach((choice, index) => {
        if (index > 0 && choice.group !== this.sortedChoices[index - 1].group) {
          result.push({ isBreak: true, key: 'break-' + index });
        }
        result.push(choice);
      });
      return result;
    }
  }
}
</script>
<style scoped lang="scss">
.option-dropdown {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: 300ms max-height cubic-bezier(.08,.7,.36,.99);
  .dropdown {
    width: 100%;
    // min-height: 4.5em;
    max-height: 4.5em;
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-between;
    align-items: center;

    //display: flex;
    //justify-content: space-between;
    //align-items: center;
    padding: 1em;
    border-bottom: 1px solid $deep-slate;
    user-select: none;
    transition: max-height 300ms ease-out, height 300ms ease-out;
    &.short {
      padding: .2em .7em .2em 1em;
    }
    .descriptor {
      display: flex;
      flex-direction: column;
      justify-content: center;
      h5 {
        color: white;
      }
      p {
        color: $muted-white;
        font-family: 'Europa Bold';
        font-size: .8rem;
        letter-spacing: 1px;
      }
    }
    .title {
      color: white;
      text-transform: uppercase;
      letter-spacing: 1px;
      span {
        color: white;
      }
      & > .dropdown-header {
        text-align: right;
      }
    }
    // Thumbnail image on dropdown header row
    .thumbnail {
      height: 32px;
      width: 32px;
      margin: 0 .3em -10px .3em;
      background-color: transparent;
      border: 4px solid $teal;
    }
    // Dropdown arrow
    .arrow {
      width: 1em;
      height: 1em;
      margin: 0 .7em -.1em .5em;
      transform: rotate(90deg);
      transition: transform 200ms ease-out;
      &.flip {
        transform: rotate(-90deg);
      }
    }
    @media #{ $desktop } {
      &:not(.short):hover {
        cursor: pointer;
        background-color: $option-hover;
      }
    }
    p.disclaimer {
      grid-column: 1 / span 2;
      padding: 0;
      color: $muted-white;
      font-size: .7rem;
      font-style: italic;
      overflow: hidden;
      height: 100%;
      max-height: 0;
      opacity: 0;
      transition: min-height 300ms ease-out,
                  max-height 300ms ease-out,
                  opacity 300ms ease-out,
                  padding 300ms ease-out;
      &.show {
        max-height: 4em;
        padding: .5em 0;
        opacity: 1;
        /*
        transition: min-height 400ms ease-out,
                    max-height 400ms ease-out,
                    opacity 400ms ease-out,
                    padding 400ms ease-out;
                    */
      }
    }
  }
  .dropdown-content {
    max-height: 0em;
    overflow: hidden;
    padding: 0 .5em 0 .5em;
    border-bottom: 0px solid $deep-slate;
    transition: max-height 250ms cubic-bezier(0.455, 0.03, 0.515, 0.955),
                border-width 250ms cubic-bezier(0.455, 0.03, 0.515, 0.955),
                padding 250ms cubic-bezier(0.455, 0.03, 0.515, 0.955);
    &.show-dropdown {
      max-height: 15em;
      padding: .5em;
      border-width: 1px;
    }
  }
  .button-wrap {
    min-width: 12em;
    max-width: 20em;
    display: flex;
    flex-flow: row-reverse wrap;
    float: right;
    button.toggle {
      height: 54px;
      width: 54px;
      margin: .2em;
      padding: 0;
      overflow: hidden;
      outline: none;
      background-color: transparent;
      border: 4px solid transparent;
      img {
        width: 100%;
        height: 100%;
      }
      &.active {
        border-color: $teal;
      }
      @media #{ $desktop } {
        &:not(.active):hover {
          border-color: rgba($teal, 0.2);
        }
      }
    }
  }
  .button-wrap.no-dropdown {
    button.toggle {
      transform: none;
      opacity: 1;
    }
  }
  .flex-break {
    flex-basis: 100%;
    height: 0;
    width: 0;
    overflow: hidden;
  }
}
</style>
